import { useMutation, useQueryClient } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { misc } from "@/lib/misc";
import {
  CreateInterviewRequest,
  HttpResponse,
  Interview,
  InterviewQueryParams,
} from "@/types";

export function useCreateAddInterview({
  companyId,
  jobId,
  queryParams,
}: {
  companyId: string;
  jobId: string;
  queryParams: InterviewQueryParams;
}) {
  const queryClient = useQueryClient();
  const queryString = misc.prepareQueryParams(queryParams).toString();

  return useMutation({
    mutationFn: async ({
      createInterviewRequest,
    }: {
      createInterviewRequest: CreateInterviewRequest;
    }) => {
      const path = `companies/${companyId}/jobs/${jobId}/interviews`;
      const res = await guacHttpClient.post<
        Interview,
        HttpResponse<Interview>,
        CreateInterviewRequest
      >(path, createInterviewRequest);

      return res.data;
    },
    onSuccess: (newInterview) => {
      queryClient.setQueryData(
        ["interviews", companyId, jobId, queryString],
        (cachedData?: Interview[]) => {
          if (!cachedData) return [newInterview];
          return [...cachedData, newInterview];
        },
      );
    },
  });
}
